/* eslint-disable */

import '../vendor/sweetalert2.min';
import '../vendor/jnotify';
import optionSelect from './option-selector';

/* global Sys:true */
/* jshint maxcomplexity:8 */
(function() {
  'use strict';

  // require("vendor/sweetalert2.min");
  // var jNotify = require("vendor/jnotify");
  // var optionSelect = require("./option-selector");

  if ($('.product-details').length > 0) {
    // initial setup for additions - other function can be found in scripts/product/option-selector.js
    initialLoad();
    checkQueryString();

    pageFunctions();

    if ($(window).width() < 768) {
      hideandshowoptions();
    }

    alignPricingBlock();

    $(window).resize(function() {
      $('.optional-inner-top').unbind();

      if ($(window).width() < 768) {
        hideandshowoptions();
      }

      alignPricingBlock();
    });

    showLeftPriceBlock();

    moveLeftPriceBlock();

    optionNotAvailable();

    optionHasChild();

    quantityBox();

    // reload on partial postback
    var prm = Sys.WebForms.PageRequestManager.getInstance();
    if (prm !== null) {
      /* jshint camelcase:false */
      prm.add_endRequest(function(sender, e) {
        /* jshint camelcase:true */
        if (sender._postBackSettings.panelsToUpdate !== null) {
          initialLoad();

          pageFunctions();

          if (window.innerWidth < 768) {
            hideandshowoptions();
          }

          alignPricingBlock();

          $(window).resize(function() {
            $('.optional-inner-top').unbind();

            if (window.innerWidth < 768) {
              hideandshowoptions();
            }

            alignPricingBlock();
          });

          showLeftPriceBlock();

          moveLeftPriceBlock();

          optionNotAvailable();

          optionHasChild();

          quantityBox();
        }
      });
    }
  }

  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function checkQueryString() {
    var length = getParameterByName('length');
    if (length) {
      var selected = $('[data-sku-name="' + length + '"]');
      if (selected) {
        selected.click();
      }
    }
  }

  function initialLoad() {
    $('.CartItemSelector input[type=checkbox], .CartItemSelector input[type=radio]').each(
      function() {
        $(this).prop('checked', false);
      },
    );

    $('.product-details-main input[type=checkbox], input[type=radio]').each(function() {
      if ($(this).is(':checked') && $(this).attr('data-cat') !== null) {
        optionSelect(
          $(this).attr('id'),
          $(this).attr('data-cat'),
          $(this).attr('value'),
          $(this).attr('data-parent'),
          $(this).attr('data-rel'),
          $(this).attr('data-rel-type'),
          $(this).attr('data-was-price'),
          $(this).attr('data-price'),
          $(this).attr('data-parent-rel'),
        );
      }
    });
  }

  function pageFunctions() {
    $('.optional-inner-main input[type="checkbox"]').click(function() {
      $(this)
        .closest('.optional-inner-row')
        .toggleClass('active-row');
    });

    $('.info-icon').click(function() {
      $(this)
        .parent()
        .parent()
        .siblings('.options-slide')
        .slideToggle();
    });

    $('.close-options').click(function() {
      $(this)
        .parent()
        .slideToggle();
    });
  }

  function showLeftPriceBlock() {
    // Show bottom add to cart (don't want them adding to cart if javascript not loaded in)
    $('.total-bottom .reload').hide();
    if ($('.total-bottom .total-col3').length > 0) {
      $('.total-bottom .total-col3').show();
    }
    $('.total-bottom input[type=submit]').show();

    if ($('body').height() > $(window).height()) {
      // show left price block on load
      setTimeout(function() {
        if (window.matchMedia('(min-width: 768px)').matches) {
          var sidenavtop =
            $('.col-xs-12.col-sm-4.col-sm-pull-8.col-md-3.col-md-pull-9').height() + 30;

          $('.polytunnel-price').css({
            position: 'absolute',
            top: sidenavtop,
          });
        }

        $('.polytunnel-price').fadeIn();
      }, 500);
    }
  }

  function moveLeftPriceBlock() {
    if ($('.left-nav').length > 0) {
      // scroll left price block on left nav height change
      $('.left-nav h2').click(function() {
        setTimeout(function() {
          var sidenavtop =
            $('.col-xs-12.col-sm-4.col-sm-pull-8.col-md-3.col-md-pull-9').height() + 30;

          if ($(window).scrollTop() - 200 < sidenavtop) {
            alignPricingBlock();
            $('.polytunnel-price').animate({
              position: 'absolute',
              top: sidenavtop,
            });
          } else {
            alignFixedPricingBlock();
            $('.polytunnel-price').css({
              position: 'fixed',
              top: '51px',
            });
          }
        }, 400);
      });

      // let observer = new IntersectionObserver((entries) => {
      //   // entries: Array of observed elements
      //   entries.forEach(entry => {
      //     if(entry.isIntersecting){
      //       $(".polytunnel-price").css({
      //         display: "block",
      //         position: "fixed",
      //         top: "auto",
      //         bottom: "0"
      //       });
      //     }
      //   });
      // });
      // const topObserve = document.querySelector('.optional2');

      // observer.observe(topObserve);

      // move left price block position as you scroll down
      $(window).scroll(function() {
        if (window.matchMedia('(min-width: 768px)').matches) {
          var sidenavtop =
            $('.col-xs-12.col-sm-4.col-sm-pull-8.col-md-3.col-md-pull-9').height() + 30;

          if ($(window).scrollTop() - 200 < sidenavtop) {
            console.log($(window).scrollTop() - 200);
            console.log(sidenavtop);
            alignPricingBlock();
            $('.polytunnel-price').css({
              position: 'absolute',
              top: sidenavtop,
            });
            if ($('.IE8').length > 0) {
              $('.polytunnel-price-arrow').css({
                left: '193px',
              });
            }
          } else {
            alignFixedPricingBlock();
            if (window.matchMedia('(min-width: 768px)').matches) {
              $('.polytunnel-price').css({
                position: 'fixed',
                top: '51px',
              });
            }
            if ($('.IE8').length > 0) {
              $('.polytunnel-price-arrow').css({
                left: '-57px',
              });
            }
          }
        }
      });
    }
  }

  function optionNotAvailable() {
    // not available message
    $('.optional-col1 .disabled').click(function(e) {
      e.preventDefault();

      var thisName = $(this)
        .next()
        .html();
      var messageType = $(this)
        .prev('label')
        .prev('input')
        .attr('data-disable');
      var message = '';

      if (messageType === 'par') {
        message = $(this)
          .prev('label')
          .prev('input')
          .attr('data-parent-message');
      } else if (messageType === 'rel') {
        var relatedId = $(this)
          .prev()
          .prev()
          .attr('data-related');
        var relatedName = $('#' + relatedId)
          .next()
          .next()
          .next()
          .html();

        // if relationship has specific message
        if ($('#' + relatedId).attr('data-rel-message').length > 0) {
          message = $('#' + relatedId).attr('data-rel-message');
        }
        // if related item is standard
        else if ($('#' + relatedId).attr('data-standard')) {
          message =
            'Please unselect the ' +
            relatedName +
            ', which is included as standard with this polytunnel, before selecting the upgrade to ' +
            thisName +
            '.';
        } else {
          message =
            'You have previously selected the ' +
            relatedName +
            '. The ' +
            thisName +
            ' is not required when using the ' +
            relatedName +
            '. ' +
            'If you wish to order the ' +
            thisName +
            ', please unselect the ' +
            relatedName +
            '.';
        }
      }

      if (message !== '') {
        notifyUser(message);
      }
    });
  }

  function optionHasChild() {
    // standard item message & deselect child message
    $('.optional-col1').click(function(e) {
      if (
        $(this)
          .children('input')
          .attr('data-standard') &&
        $(this)
          .children('input')
          .attr('data-rel-type').length === 0
      ) {
        // standard item message
        var relationshipId = $(this)
          .children('input')
          .attr('data-rel');
        if (relationshipId === '0' || $(`input[data-rel=${relationshipId}]`).length === 1) {
          e.preventDefault();

          var thisName = $(this)
            .children('p')
            .html();

          var message =
            'A ' +
            thisName +
            ' is supplied as standard with this polytunnel. This option cannot be unselected.';

          if (message !== '') {
            notifyUser(message);
          }
        }
      } else if (
        $(this)
          .children('input')
          .attr('data-child')
      ) {
        // deselect child message
        e.preventDefault();

        var childId = $(this)
          .children('input')
          .attr('data-child');
        var childName = $('#' + childId)
          .next()
          .next()
          .next()
          .html();

        let message = `This option can only be unselected after unselecting the ${childName}.`;

        if (message !== '') {
          notifyUser(message);
        }
      }
    });
  }

  function hideandshowoptions() {
    $('.optional-inner-top').click(function() {
      $(this)
        .siblings('.optional-inner-main')
        .slideToggle();
      $(this)
        .parent('.optional-inner')
        .siblings('.optional-inner-main')
        .slideToggle();
      $(this)
        .parent('.optional-inner')
        .siblings('.optional-inner-main')
        .children('.optional-inner')
        .children('.optional-inner-main')
        .slideToggle();
    });
  }

  function alignPricingBlock() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      var prodDetailOffset = $('.product-details').offset().left;
      var leftMenuOffset = $('.left-nav').offset().left;
      var leftPos = prodDetailOffset - leftMenuOffset;
      $('.polytunnel-price').css({
        'margin-left': 0,
        left: -leftPos,
      });
    }
  }

  function alignFixedPricingBlock() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      var leftMenuOffset = $('.mainInner').offset().left;
      leftMenuOffset -= 5;
      $('.polytunnel-price').css({
        left: leftMenuOffset,
      });
    }
  }

  function quantityBox() {
    if ($('.quantity-box').length > 0) {
      $('.quantity-box').keydown(function(e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if (
          $.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode === 65 && e.ctrlKey === true) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)
        ) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if (
          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
          (e.keyCode < 96 || e.keyCode > 105)
        ) {
          e.preventDefault();
        }
      });
    }
  }

  function notifyUser(message) {
    swal({
      text: message,
      button: 'OK',
      customClass: 'jNotify',
      background: '#356347',
      buttonsStyling: false,
    });
    //  jNotify(message, {
    //          autoHide: false, // added in v2.0
    //          clickOverlay: false, // added in v2.0
    //          MinWidth: 250,
    //          TimeShown: 3000,
    //          ShowTimeEffect: 200,
    //          HideTimeEffect: 200,
    //          LongTrip: 20,
    //          HorizontalPosition: 'center',
    //          VerticalPosition: 'center',
    //          ShowOverlay: true,
    //          ColorOverlay: '#000',
    //          OpacityOverlay: 0.3,
    //          onClosed: function () { // added in v2.0

    //          },
    //          onCompleted: function () { // added in v2.0

    //          }
    //      }
    //);
  }

  /* WTF!? */
  /* jshint ignore:start */
  eval(
    (function(p, a, c, k, e, r) {
      e = function(c) {
        return (
          (c < a ? '' : e(parseInt(c / a))) +
          ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36))
        );
      };
      if (!''.replace(/^/, String)) {
        while (c--) r[e(c)] = k[c] || e(c);
        k = [
          function(e) {
            return r[e];
          },
        ];
        e = function() {
          return '\\w+';
        };
        c = 1;
      }
      while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
      return p;
    })(
      "(6($){$.5={19:{m:9,1e:13,1h:P,k:1j,F:P,H:P,A:15,1b:'y',I:'d',x:9,1c:'#1i',18:0.3,n:16,o:16},G:6(b,j,f){4=$.1k({},$.5.19,j);7($(\"#\"+f).r==0)$8=$.5.1f(f,b);U=g($(L).1s());R=g($(L).1u());C=g($(L).1v());D=g($(L).1w());s=$.5.q(4.I);17=$.5.v(4.1b);7(4.x&&$(\"#h\").r==0)$.5.14($8);$.5.12(b)},1f:6(f,b){$8=$('<11 f=\"'+f+'\"/>').t({i:0,1l:4.1h}).1n(b).1d('1g');z $8},q:6(K){B(K){a'd':p q=C+g($8.S(9)/2);c;a'y':p q=C+(R/2)-(g($8.S(9))/2);c;a'Q':p q=C+R-g($8.S(9));c}z q},v:6(K){B(K){a'Z':p v=D;c;a'y':p v=D+(U/2)-(g($8.10(9))/2);c;a'1t':p v=D+U-g($8.10(9));c}z v},12:6(b){$8.t({d:s,Z:17});B(4.I){a'd':$8.u({d:s+4.A,i:1},4.F,6(){7(4.o)4.o()});7(4.m)$.5.l();M $8.t('N','T').J(6(e){$.5.l()});c;a'y':$8.u({i:1},4.F,6(){7(4.o)4.o()});7(4.m)$.5.l();M $8.t('N','T').J(6(e){$.5.l()});c;a'Q':$8.u({d:s-4.A,i:1},4.F,6(){7(4.o)4.o()});7(4.m)$.5.l();M $8.t('N','T').J(6(e){$.5.l()});c}},14:6(1m){p 1a=$('<11 f=\"h\" />').t({1o:4.1c,i:4.18}).1d('1g').1p();7(4.1e)1a.J(6(e){e.1q();4.k=0;$.5.l()})},l:6(){B(4.I){a'd':7(!4.m)4.k=0;$8.V(9,9).W(4.k).u({d:s-4.A,i:0},4.H,6(){$(X).w();7(4.x&&$(\"#h\").r>0)$(\"#h\").w();7(4.n)4.n()});c;a'y':7(!4.m)4.k=0;$8.V(9,9).W(4.k).u({i:0},4.H,6(){$(X).w();7(4.x&&$(\"#h\").r>0)$(\"#h\").w();7(4.n)4.n()});c;a'Q':7(!4.m)4.k=0;$8.V(9,9).W(4.k).u({d:s+4.A,i:0},4.H,6(){$(X).w();7(4.x&&$(\"#h\").r>0)$(\"#h\").w();7(4.n)4.n()});c}},E:6(f){7($('#'+f).r>0)z 13;M z 9}};5=6(b,j){7($.5.E('5'))$.5.G(b,j,'5')};Y=6(b,j){7($.5.E('Y'))$.5.G(b,j,'Y')};O=6(b,j){7($.5.E('O'))$.5.G(b,j,'O')}})(1r);",
      62,
      95,
      '||||opts|jNotify|function|if|Div|true|case|msg|break|top||id|parseInt|jOverlay|opacity|options|TimeShown|_close|autoHide|onClosed|onCompleted|var|vPos|length|posTop|css|animate|hPos|remove|ShowOverlay|center|return|LongTrip|switch|ScrollTop|ScrollLeft|_isReadable|ShowTimeEffect|init|HideTimeEffect|VerticalPosition|click|pos|window|else|cursor|jError|200|bottom|HeightDoc|outerHeight|pointer|WidthDoc|stop|delay|this|jSuccess|left|outerWidth|div|_show|false|_showOverlay||null|posLeft|OpacityOverlay|defaults|overlay|HorizontalPosition|ColorOverlay|appendTo|clickOverlay|_construct|body|MinWidth|000|1500|extend|minWidth|el|html|backgroundColor|show|preventDefault|jQuery|width|right|height|scrollTop|scrollLeft'.split(
        '|',
      ),
      0,
      {},
    ),
  );
  /* jshint ignore:end */
})();
